<ion-content [fullscreen]="true">

    <div class="form-content">
        <header>
           <h1>Invista agora e seja um franqueado</h1>
            <ion-icon name="close-outline" (click)="closeModal()"></ion-icon>
        </header>

        <p>
            Preencha o formulário com seus dados.
            Em breve, entraremos em contato para explorar as melhores oportunidades! :)
        </p>

        <form [formGroup]="form" class="form-container">
            @for(field of fields; track field) {
            <div class="form-item" [class.inline]="field.inline">
                <app-input [data]="field" [parentForm]="form"></app-input>
            </div>
            }

            <app-button [dots]="true"
                [text]="'Continuar'" (action)="validate()"></app-button>
        </form>
    </div>
</ion-content>
